<!--抄表结算单列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">抄表结算方案</span>
      </div>
    </div>
    <div class="content-header">
      <div class="left">
        <Input
          v-model="page.value"
          placeholder="根据条件搜索"
          @on-enter="getData(1)"
        >
          <Select v-model="page.cond" slot="prepend" style="width: 120px">
            <Option value="id">编号</Option>
            <Option value="company_name">企业名称</Option>
            <Option value="sn">设备序列号</Option>
            <Option value="machine_type_name">设备型号</Option>
            <Option value="site_name">站点</Option>
          </Select>
          <Button slot="append" icon="ios-search" @click="getData(1)"></Button>
        </Input>
      </div>
      <div class="right">
        <Poptip title="导出Excel" placement="right" trigger="hover">
          <Button style="margin-right: 5px">导出报表</Button>
          <div slot="content">
            <Button
              type="primary"
              style="margin-right: 5px"
              @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
        <Button
          type="primary"
          @click="$router.push({ name: 'meter-order-add' })"
          >结算单生成</Button
        >
      </div>
    </div>
    <Table :data="data" :columns="columns" :loading="tableLoading" />
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        :current="page.p + 1"
        show-elevator
        show-sizer
        show-total
      />
    </div>
    <div
      class="pdf"
      id="pdf"
      style="width: 100%; position: relative; padding: 100px"
    ></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
  data () {
    return {
      page: {
        p: 0,
        l: 10,
        cond: 'id',
        value: ''
      },
      tableLoading: false,
      total: 0,
      data: [],
      columns: [
        { key: 'id', width: 60, title: '编号', width: 60 },
        {
          key: 'create_time',
          width: 135,
          title: '生成日期',
          render: (h, data) => {
            return h('span', this.$moment(data.row.create_time))
          }
        },
        { key: 'company_name', title: '企业名称', width: 150 },
        { key: 'machine_type_name', title: '设备型号', width: 130 },
        { key: 'sn', title: '设备序列号', width: 140 },
        { key: 'site_name', title: '站点', width: 150 },
        // {key: "create_time",title: "生成日期",render: (h,data)=>{return h("span",this.$moment(data.row.create_time))}},
        {
          key: 'start_time',
          width: 135,
          title: '本次结算开始',
          render: (h, data) => {
            return h('span', this.$moment(data.row.start_time))
          }
        },
        {
          key: 'end_time',
          width: 135,
          title: '本次结算截止',
          render: (h, data) => {
            return h('span', this.$moment(data.row.end_time))
          }
        },
        {
          key: 'site_name',
          title: '抄表费用',
          width: 100,
          render: (h, data) => {
            return h('span', data.row.total - data.row.money)
          }
        },
        { key: 'money', title: '其他费用', width: 100 },
        { key: 'money_log', title: '费用补充', tooltip: true, width: 100 },
        { key: 'total', title: '合计', width: 100 },
        { key: 'log', title: '备注', tooltip: true, width: 150 },
        {
          key: 'operator',
          width: 125,
          title: '操作',
          fixed: 'right',
          export_ignore: true,
          render: (h, data) => {
            return h('div', [
              h(
                'Button',
                {
                  props: { type: 'error', size: 'small' },
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '是否删除',
                        content: '<p>是否删除该抄表结算单?</p>',
                        onOk: () => {
                          this.DelMeterResult({ id: data.row.id }).then(
                            (res) => {
                              this.getData()
                            }
                          )
                        }
                      })
                    }
                  }
                },
                '删除'
              ),
              h(
                'Button',
                {
                  props: { type: 'primary', size: 'small' },
                  on: {
                    click: () => {
                      this.drawMeterOrder(data.row)
                    }
                  }
                },
                '下载'
              )
            ])
          }
        }
      ]
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    getPreData (data) {
      return new Promise((resolve) => {
        let params = {
          company_id: data.company_id,
          current_id: data.id,
          start_id: data.meter_start_id,
          end_id: data.meter_end_id,
          charge_id: data.meter_charge_id,
          agent_id: data.agent_id
        }
        this.GetPreMeterData(params).then((res) => {
          resolve(res)
        })
      })
    },
    drawMeterOrder (data) {
      console.log(data)
      this.$Message.success('正在生成PDF，请稍等')
      this.getPreData(data).then((res) => {
        res.start.create_time = this.$moment(res.start.create_time)
        res.end.create_time = this.$moment(res.end.create_time)
        res.last.create_time = this.$moment(res.last.create_time)
        let start = res.start,
          end = res.end,
          last = res.last,
          code = 'JS' + `${data.id}`.padStart(6, '0')
        let html = `
        <!DOCTYPE html>
          <html>
          <head>
            <title>抄表结算单</title>
          </head>
          <body style="margin:0;padding:0;" id="body">
            <div style="padding:0 40px;font-size: 12px">
            <div style="position: relative;border-bottom: 3px solid;padding: 48px 0 8px;">
              <div style="font-size: 24px;font-weight: bold;">抄表结算单</div>
              <span style="position: absolute;right: 0;top: 50px;line-height: 33px;">${code}</span>
            </div>
            <div>
              <p style="line-height:40px">用户名称: ${res.company_contacts}</p>
              <p style="line-height:40px">联系电话: ${res.company_tel}</p>
            </div>
            <div style="border-bottom: 1px solid #000;"></div>

            <div style="font-size: 18px;font-weight: 500;margin: 40px 0 10px 0;">设备信息</div>
            <div style="border-bottom: 1px solid #000;"></div>
            <div>
              <p style="line-height:40px">设备型号: ${
  data.machine_type_name
} (${data.sn})</p>
              <p style="line-height:40px">结算方案: ${res.describe || ''}</p>
            </div>
            <div style="border-bottom: 1px solid #000;"></div>
            <div style="font-size: 18px;font-weight: 500;margin: 40px 0 10px 0;">抄表费用</div>
            <div style="border-bottom: 1px solid #000;margin-bottom: 12px"></div>
            <table style="border-collapse: collapse;width: 100%;text-align: right;font-size: 12px;">
              <tr>
                <td style="text-align: left">时间</td>
                <td>总计数</td>
                <td>黑白页数</td>
                <td>彩色页数</td>
                <td>A3黑色页数</td>
                <td>A3彩色页数</td>
                <td>双色页数</td>
              </tr>
              <tr>
                <td style="text-align: left">上次截止:${
  last.create_time || '-'
}</td>
                <td>${last.total || '-'}</td>
                <td>${last.black_num || '-'}</td>
                <td>${last.color_num || '-'}</td>
                <td>${last.black_a3_num || '-'}</td>
                <td>${last.color_a3_num || '-'}</td>
                <td>${last.both_num || '-'}</td>
              </tr>
              <tr>
                <td style="text-align: left">本次开始:${
  start.create_time || '-'
}</td>
                <td>${start.total}</td>
                <td>${start.black_num}</td>
                <td>${start.color_num}</td>
                <td>${start.black_a3_num}</td>
                <td>${start.color_a3_num}</td>
                <td>${start.both_num}</td>
              </tr>
              <tr>
                <td style="text-align: left">本次截止:${
  end.create_time || '-'
}</td>
                <td>${end.total}</td>
                <td>${end.black_num}</td>
                <td>${end.color_num}</td>
                <td>${end.black_a3_num}</td>
                <td>${end.color_a3_num}</td>
                <td>${end.both_num}</td>
              </tr>
              <tr>
                <td style="text-align: left">结算印张:</td>
                <td>${end.total - start.total}</td>
                <td>${end.black_num - start.black_num}</td>
                <td>${end.color_num - start.color_num}</td>
                <td>${end.black_a3_num - start.black_a3_num}</td>
                <td>${end.color_a3_num - start.color_a3_num}</td>
                <td>${end.both_num - start.both_num}</td>
              </tr>
              <tr>
                <td style="text-align: left" colspan="7">产生费用: ${
  res.total
}</td>
              </tr>
            </table>
            <div style="border-bottom: 1px solid #000;margin-top: 12px"></div>
            <div style="font-size: 18px;font-weight: 500;margin: 40px 0 10px 0;">其他费用</div>
            <div style="border-bottom: 1px solid #000;"></div>
            <div>
              <p style="line-height:40px">费用描述: ${res.money_log || ''}</p>
              <p style="line-height:40px">产生费用: ${res.money}</p>
            </div>
            <div style="border-bottom: 1px solid #000;"></div>
            <div style="font-size: 18px;font-weight: 500;margin: 40px 0 10px 0;">备注说明</div>
            <div style="border-bottom: 1px solid #000;"></div>
            <p style="line-height:40px>${res.log}</p>
            <div style="border-bottom: 1px solid #000;"></div>
            <div style="text-align: right;margin: 10px 0;color: #2d8cf0;width: calc(100% - 80px);margin-left:40px;line-height:40px">合计应收: ￥${parseFloat(
    res.money + res.total
  ).toFixed(2)}</div>
            <div style="width: calc(100% - 80px);margin-left:40px;border-top: 1px solid #000;display: flex;flex-wrap: wrap;line-height: 30px;">
              <div style="width: 50%;text-align: left;">服务商</div>
              <div style="width: 50%;text-align: right;">服务电话</div>
              <div style="width: 50%;text-align: left;">${res.agent_name}</div>
              <div style="width: 50%;text-align: right;">${res.agent_tel}</div>
            </div>
          </body>
          </div>
          </html>
      `
        document.getElementById('pdf').innerHTML = html
        let num = data.id.toString().padStart(6, '0')
        let title = 'JS' + num + data.site_name + data.sn
        setTimeout(() => {
          this.downPdf(title)
        }, 500)
        /* let wind = window.open();
        wind.document.body.innerHTML = html;
        wind.print(); */
      })
    },
    getData (filter) {
      if (filter) {
        this.page.p = 0
      }
      this.tableLoading = true
      this.GetMeterResult(this.page).then((res) => {
        this.tableLoading = false
        this.data = res.data
        this.total = res.total
      })
    },
    downPdf (title = 'settle') {
      html2Canvas(document.querySelector('#pdf'), {
        allowTaint: true
      }).then(function (canvas) {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = (contentWidth / 592.28) * 841.89
        let leftHeight = contentHeight
        let position = 0
        let imgWidth = 595.28
        let imgHeight = (592.28 / contentWidth) * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let PDF = new JsPDF('', 'pt', 'a4')
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }

        document.querySelector('#pdf').innerHTML = ''
        PDF.save(title + '.pdf')
      })
    },
    exportData (is_all) {
      let params = {
        title: [],
        key: [],
        autoWidth: true,
        filename: '抄表结算方案'
      }
      this.columns.map((item) => {
        if (item.export_ignore) {
          return
        }
        params.title.push(item.title)
        params.key.push(item.key)
      })
      if (is_all) {
        let temp = JSON.parse(JSON.stringify(this.page))
        temp.l = 10000
        temp.p = 0
        this.GetMeterResult(temp).then((res) => {
          res.data.map(item => {
            item.create_time = this.$moment(item.create_time)
            item.start_time = this.$moment(item.start_time)
            item.end_time = this.$moment(item.end_time)
            item.site_name = item.total - item.money
          })
          params.data = res.data
          excel.export_array_to_excel(params)
        })
      } else {
        let data = JSON.parse(JSON.stringify(this.data))
        data.map(item => {
          item.create_time = this.$moment(item.create_time)
          item.start_time = this.$moment(item.start_time)
          item.end_time = this.$moment(item.end_time)
          item.site_name = item.total - item.money
        })
        params.data = data
        excel.export_array_to_excel(params)
      }
    },
    ...mapActions(['GetMeterResult', 'GetPreMeterData', 'DelMeterResult'])
  },
  computed: mapGetters({})
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
